export default [
  {
    name: 'Admin',
    type: 'admin',
    description: ' - (grant admin powers, delete users, restore trash, billing)'
  },
  {
    name: 'Super user',
    type: 'super user',
    description: ' - (invite users, grant super user powers, templates)'
  },
  {
    name: 'Regular user',
    type: 'user',
    description: null
  }
]
